import { useEffect, useState } from 'react';
import { listingService } from '../services/apiService';

/**
 * Fetch similar / cross-sell listings for a catalog node.
 */
export function useCrossSell(nodeId, excludeListingId, limit = 12) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!nodeId) {
      setItems([]);
      return undefined;
    }

    let cancelled = false;

    listingService
      .getCrossSell(nodeId, { excludeListingId, limit })
      .then((res) => {
        if (!cancelled) setItems(Array.isArray(res?.items) ? res.items : []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });

    return () => {
      cancelled = true;
    };
  }, [nodeId, excludeListingId, limit]);

  return items;
}
